import type { SVGProps } from 'react';

const SvgIndexIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M4.29 5.29C4.11 5.48 4 5.74 4 6s.11.52.29.71q.15.135.33.21c.12.05.25.08.38.08s.26-.03.38-.08.24-.12.33-.21C5.89 6.52 6 6.26 6 6s-.11-.52-.29-.71c-.38-.37-1.04-.37-1.42 0m0 8c-.18.19-.29.45-.29.71s.11.52.29.71c.19.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.38-.37-1.04-.37-1.42 0m0-4c-.18.19-.29.45-.29.71s.11.52.29.71c.19.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.38-.37-1.04-.37-1.42 0M9 7h10c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1m10 6H9c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1M5.38 17.08c-.37-.15-.81-.07-1.09.21-.18.19-.29.45-.29.71s.11.52.29.71q.15.135.33.21c.12.05.25.08.38.08s.26-.03.38-.08q.195-.075.33-.21c.18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.09-.09-.21-.16-.33-.21M19 17H9c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1m0-8H9c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgIndexIcon;
